var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgRLogo(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.35 16"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M19.35 16h-3.37l-4.59-6.58H6.62L4.69 6.68h9.71c.96 0 1.76-.87 1.75-1.97 0-1.07-.79-1.94-1.75-1.94H1.94L0 0h13.86c1.57 0 2.84.49 3.78 1.48.85.89 1.27 1.95 1.27 3.22 0 1.06-.38 2.01-1.12 2.84-.74.84-1.76 1.37-3.03 1.64l4.59 6.81z",
    fill: "#1d1c39",
    fillRule: "evenodd"
  })));
}
export default SvgRLogo;